module.exports = __webpack_public_path__ + "static/media/dine_in_protocol.6d719425.jpg";